import type { PartnerOffice, PartnerPostMetaData } from "./type";

export const mapPartnerOffices = (officeMetaData: PartnerPostMetaData): PartnerOffice => ({
	id: officeMetaData.id,
	name: officeMetaData.title.rendered,
	address: officeMetaData.address,
	openingHours: officeMetaData.opening_hours,
	contactInfo: officeMetaData.contact_person,
	imgSrc: officeMetaData.thumbnail,
	imgAlt: officeMetaData.title.rendered,
	longitude: officeMetaData.longitude,
	latitude: officeMetaData.latitude,
	consultantId: officeMetaData.consultant_ID,
});
